import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { FormService } from "../../../@core/api/form.service";
import { CampaignProjectService } from "../../../@core/api/campaign-project.service";
import { Form } from "../../../@core/data/form";
import { Campaign } from "../../../@core/data/campaign";
import { FormFieldComponent } from "../form-field/form-field.component";
import { Router } from "@angular/router";

@Component({
  selector: "ngx-form-new",
  templateUrl: "./form-new.component.html",
  styleUrls: ["./form-new.component.scss"],
})
export class FormNewComponent implements OnInit {
  id: string;
  loading: boolean = false;
  form: Form = { name: "", uid: "", id: "", settings: {}, fields: [] };
  campaigns: Campaign[] = [];
  blocking = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private formService: FormService,
    private campaignService: CampaignProjectService
  ) {}

  async ngOnInit() {
    let id = this.route.snapshot.params["id"];

    if (id) {
      this.loading = true;
      this.id = id;
      this.form = <Form>await this.formService.getForm(id);
    }

    this.campaigns = <any>(
      await this.campaignService.getCampaigns(
        { pageNumber: 0, perPage: 1000 },
        {},
        {}
      )
    );

    this.loading = false;

    if (!this.form.notAllowed) {
      this.form.notAllowed = {};
    }

    Object.keys(this.form.notAllowed).map((k) => {
      this.blocking.push({
        id: k,
        values: this.form.notAllowed[k].values,
        title: this.form.notAllowed[k].title,
      });
    });
  }

  addField() {
    this.form.fields.push({});
  }

  removeField(i) {
    this.form.fields.splice(i, 1);
  }

  addBlockField(i) {
    this.blocking.push({
      id: "",
      values: "",
      title: "",
    });
  }

  removeBlockField(i) {
    this.blocking.splice(i, 1);
  }

  async updateField(data, index) {
    this.form.fields[index] = data;
  }

  move(direction, index) {
    switch (direction) {
      case "down":
        if (index < this.form.fields.length - 1) {
          let moving = this.form.fields[index];
          this.form.fields[index] = this.form.fields[index + 1];
          this.form.fields[index + 1] = moving;
        }
        break;
      case "up":
        if (index > 0) {
          let moving = this.form.fields[index];
          this.form.fields[index] = this.form.fields[index - 1];
          this.form.fields[index - 1] = moving;
        }
        break;

      default:
        break;
    }
  }

  async save() {
    this.form.notAllowed = this.blocking;
    if (this.id) {
      console.log(this.form);

      try {
        await this.formService.editForm(this.form, this.id);
        this.router.navigate(["home", "forms"]);
      } catch (e) {
        console.error(e);
      }
    } else {
      try {
        let data = <any>await this.formService.createForm(this.form);
        this.id = data.id;
        this.router.navigate(["home", "forms"]);
      } catch (e) {
        console.error(e);
      }
    }
  }
}
